import React, { Component } from "react";
import "../../Common/Common.css";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";

import ChemistOrderView from "./ChemistOrderView";

import ReactPaginate from "react-paginate";
var dateFormat = require("dateformat");

class ChemistOrder extends Component {
  constructor(props) {
    super(props);
    this.paginationreset = React.createRef();
    this.state = {
      showDetailModal: false,
      filterValue: "",
      ordertoSearch: "",
      page: 0,
      perPage: 10,
    };
  }

  componentDidMount() {
    this.props.fetchChemistOrders({
      page: undefined,
      searchquery: this.state.ordertoSearch,
      filter: this.state.filterValue,
    });
  }

  showOrderDetail = (item) => {
    this.setState(
      {
        showDetailModal: true,
        orderToShow: item,
      },
      () => {
        this.props.ChemistOrdersview({
          item: this.state.orderToShow,
          page: undefined,
        });
      }
    ); //Synchronised call
  };

  closeDetailModal = () => {
    this.setState({
      showDetailModal: false,
    });
    this.paginationreset.current.resetitemPage();
  };

  onfilterChange = (event) => {
    this.setState(
      {
        filterValue: event.target.value,
        page: 0,
        ordertoSearch: "",
      },
      () => {
        this.props.fetchChemistOrders({
          page: undefined,
          searchquery: this.state.ordertoSearch,
          filter: this.state.filterValue,
        });
      }
    );
  };

  searchChemistOrders = (event) => {
    this.setState(
      {
        ordertoSearch: event.target.value,
        page: 0,
        filterValue: "",
      },
      () => {
        this.props.fetchChemistOrders({
          page: undefined,
          searchquery: this.state.ordertoSearch,
          filter: this.state.filterValue,
        });
      }
    ); //synchronous call
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.pageSelected({
      page: selectedPage + 1,
      searchquery: this.state.ordertoSearch,
      filter: this.state.filterValue,
    });
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  render() {
    const count = this.props.chemistOrdersCount;
    let p = this.state.page + 1;
    let chemistorderspageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Chemist Orders</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={this.state.filterValue}
                    onChange={this.onfilterChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="created">Created</option>
                    <option value="accepted">Accepted</option>
                    {/* <option value="paid">Paid</option> */}
                    <option value="shipmentReady">Dispatched</option>
                    <option value="delivered">Delivered</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="rejected">Rejected</option>
                    <option value="expired">Expired</option>
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Order ID/Org Name"
                      value={this.state.ordertoSearch}
                      onChange={this.searchChemistOrders}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th style={{ width: "70px" }}>SL NO</th>
                    <th>ORDER ID</th>
                    <th>CHEMIST Org Name</th>
                    <th>DISTRIBUTOR Org Name</th>
                    <th style={{ width: "100px" }}>STATUS</th>
                    <th>CREATED DATE & TIME</th>
                    <th style={{ width: "100px" }}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.chemistOrderDetails &&
                    this.props.chemistOrderDetails.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.orderNo ? item.orderNo : null}
                        </td>
                        <td className="cmn_Cap">
                          {/* {item !== null && item.orderFrom
                            ? item.orderFrom.name + " " + item.orderFrom.lName
                            : null} */}
                          {item !== null && item.orderFromName
                            ? item.orderFromName
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {/* {item !== null && item.orderTo
                            ? item.orderTo.name + " " + item.orderTo.lName
                            : null} */}
                          {item !== null && item.orderToName
                            ? item.orderToName
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                          item.status &&
                          item.status === "shipmentReady"
                            ? "Dispatched"
                            : item.status}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.createdAt
                            ? dateFormat(item.createdAt, "dd-mmm-yyyy, h:MM TT")
                            : null}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.showOrderDetail({ item: item })
                              }
                            ></i>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <ChemistOrderView
                ref={this.paginationreset}
                show={this.state.showDetailModal}
                close={this.closeDetailModal}
                orderToShow={this.state.orderToShow}
                chemistOrderDtls={this.props.chemistOrderDtls}
                chemistOrderDtlsCount={this.props.chemistOrderDtlsCount}
                itempageSelected={this.props.itempageSelected}
              />
              {(this.props.chemistOrderDetails === undefined ||
                (this.props.chemistOrderDetails &&
                  this.props.chemistOrderDetails.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Orders Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {chemistorderspageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={chemistorderspageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default ChemistOrder;
